import RootLayout from '../src/layouts/root-layout';

function App() {

  return (
    <div className="App">
    <>
      <RootLayout/>
    </>
    </div>
  );
}

export default App;
